import { render, staticRenderFns } from "./AtosInfralegaisPorEnteFederativoPorAno.vue?vue&type=template&id=5b290a46&scoped=true"
import script from "./AtosInfralegaisPorEnteFederativoPorAno.vue?vue&type=script&lang=js"
export * from "./AtosInfralegaisPorEnteFederativoPorAno.vue?vue&type=script&lang=js"
import style0 from "./AtosInfralegaisPorEnteFederativoPorAno.vue?vue&type=style&index=0&id=5b290a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b290a46",
  null
  
)

export default component.exports